import { PostData } from "../post.models";

export interface UnsupportedPostProps extends PostData {}

export function UnsupportedPost(props: PostData) {
  return <div>Unsupported Post Type {props.type}</div>;
}
